import Following from "../components/BuyerProfile/Following/Following";
import Inquiry from "../components/BuyerProfile/Inquiry";
import OrderList from "../components/BuyerProfile/Orders/OrderList";
import Orders from "../components/BuyerProfile/Orders/Orders";
import Overview from "../components/BuyerProfile/Overview";
import ProfileDetails from "../components/BuyerProfile/ProfileDetails";
// import SupportTickets from "../components/BuyerProfile/SupportTickets";
import TicketList from "../components/BuyerProfile/Tickets/TicketsList";
import Tickets from "../components/BuyerProfile/Tickets/Tickets";
import Wishlist from "../components/BuyerProfile/Wishlist";
import TrackOrder from "../components/UI/Orders/TrackOrder";
import ViewDetails from "../components/UI/Orders/ViewDetails";
import StoreManager from "../components/BuyerProfile/StoreManager";
import LogOut from "../components/UI/LogOut";

import RaiseTicket from "../components/UI/SupportTickets/RaiseTicket";
import TicketDetails from "../components/UI/SupportTickets/TicketDetails";

import MyProducts from "../components/SellerDashboard/MyProducts";
import PricingPlan from "../components/SellerDashboard/PricingPlan";
import ReceivedOrders from "../components/SellerDashboard/ReceivedOrders";
import SellerFollowers from "../components/SellerDashboard/SellerFollowers";
import SellerInquiry from "../components/SellerDashboard/SellerInquiry";
import SellerOverview from "../components/SellerDashboard/SellerOverview";
import SellerReviews from "../components/SellerDashboard/SellerReviews";
import SellerPayment from "../components/SellerDashboard/Payment/SellerPayment";
import PaymentList from "../components/SellerDashboard/Payment/PaymentList";
import PaymentSettings from "../components/SellerDashboard/Payment/PaymentSettings";
import MyStore from "../components/SellerDashboard/MyStore/MyStore";
import OrderApproval from "../components/UI/SellerOrder/OrderApproval";
import OrderDetails from "../components/UI/SellerOrder/OrderDetails";

const ordersLink = [
  {
    type: "Overview",
    img: require("../assets/BuyerProfile/Panel/Overview.png"),
    url: "overview",
    element: <Overview />,
  },
  {
    type: "Store Manager",
    img: require("../assets/BuyerProfile/Panel/store-management.png"),
    url: "storeManager",
    isStoreManager: true,
    element: <StoreManager />,
  },
  {
    type: "Profile Details",
    img: require("../assets/BuyerProfile/Panel/ProfileDetails.png"),
    url: "profileDetails",
    element: <ProfileDetails />,
  },
  {
    type: "Orders",
    img: require("../assets/BuyerProfile/Panel/Orders.png"),
    url: "orderList",
    element: <Orders />,
    children: [
      {
        type: "Orders",
        img: require("../assets/BuyerProfile/Panel/Orders.png"),
        url: "",
        element: <OrderList />,
      },
      {
        type: "Orders",
        img: require("../assets/BuyerProfile/Panel/Orders.png"),
        url: "track/:orderId",
        element: <TrackOrder />,
      },
      {
        type: "Orders",
        img: require("../assets/BuyerProfile/Panel/Orders.png"),
        url: "view/:orderId",
        element: <ViewDetails />,
      },
    ],
  },
  {
    type: "Inquiry",
    img: require("../assets/BuyerProfile/Panel/Inquiry.png"),
    url: "inquiry",
    element: <Inquiry />,
  },
  // {
  //   type: "Chat Box",
  //   img: require("../assets/BuyerProfile/Panel/ChatBox.png"),
  //   url: "chat",
  // },
  {
    type: "Wishlist",
    img: require("../assets/BuyerProfile/Panel/Whishlist.png"),
    url: "whishlist",
    element: <Wishlist />,
  },
  {
    type: "Support Tickets",
    img: require("../assets/BuyerProfile/Panel/Tickets.png"),
    url: "ticketList",
    element: <Tickets />,
    children: [
      {
        type: "Support Tickets",
        img: require("../assets/BuyerProfile/Panel/Tickets.png"),
        url: "",
        element: <TicketList />,
      },
      {
        type: "Support Tickets",
        img: require("../assets/BuyerProfile/Panel/Tickets.png"),
        url: "newTicket/:orderId",
        element: <RaiseTicket />,
      },
      {
        type: "Support Tickets",
        img: require("../assets/BuyerProfile/Panel/Tickets.png"),
        url: "viewTickets/:orderId",
        element: <TicketDetails />,
      },
    ],
  },
  {
    type: "Following",
    img: require("../assets/BuyerProfile/Panel/Following.png"),
    url: "following",
    element: <Following />,
  },
  {
    type: "Logout",
    img: require("../assets/BuyerProfile/Panel/Logout.png"),
    url: "logout",
    isLogout: true,
    element: <LogOut />,
  },
];

export { ordersLink };

const StoreManagerLink = [
  {
    type: "Dashboard",
    img: require("../assets/SellerDashboard/SellerPanel/SellerOverview.png"),
    url: "SellerDashboard",
    element: <SellerOverview />,
  },
  {
    type: "My Products",
    img: require("../assets/SellerDashboard/SellerPanel/MyProducts.png"),
    url: "SellerProducts",
    element: <MyProducts />,
  },
  {
    type: "Orders",
    img: require("../assets/SellerDashboard/SellerPanel/SellerOrders.png"),
    url: "ReceivedOrders",
    element: <ReceivedOrders />,
    children: [
      {
        type: "Order Approval",
        img: require("../assets/SellerDashboard/SellerPanel/SellerOrders.png"),
        url: "orderId",
        element: <OrderApproval />,
      },
      {
        type: "Order View",
        img: require("../assets/SellerDashboard/SellerPanel/SellerOrders.png"),
        url: "orderDetails/orderId",
        element: <OrderDetails />,
      },
    ],
  },
  {
    type: "Payment",
    img: require("../assets/SellerDashboard/SellerPanel/Payment.png"),
    url: "paymentList",
    element: <SellerPayment />,
    children: [
      {
        type: "Payment",
        img: require("../assets/SellerDashboard/SellerPanel/Payment.png"),
        url: "",
        element: <PaymentList />,
      },
      {
        type: "Payment",
        img: require("../assets/SellerDashboard/SellerPanel/Payment.png"),
        url: "paymentSettings/:orderId",
        element: <PaymentSettings />,
      },
    ],
  },
  {
    type: "Inquiry",
    img: require("../assets/SellerDashboard/SellerPanel/SellerInquiry.png"),
    url: "SellerInquiry",
    element: <SellerInquiry />,
  },
  {
    type: "Followers",
    img: require("../assets/SellerDashboard/SellerPanel/Followers.png"),
    url: "SellerFollowers",
    element: <SellerFollowers />,
  },
  {
    type: "Pricing Plan",
    img: require("../assets/SellerDashboard/SellerPanel/PricingPlan.png"),
    url: "PricingPlan",
    element: <PricingPlan />,
  },
  {
    type: "My Webstore",
    img: require("../assets/SellerDashboard/SellerPanel/MyStore.png"),
    url: "MyStore",
    element: <MyStore />,
  },
  {
    type: "Reviews",
    img: require("../assets/SellerDashboard/SellerPanel/SellerReviews.png"),
    url: "SellerReviews",
    element: <SellerReviews />,
  },
];

export { StoreManagerLink };

const RaiseTickets = [
  {
    type: "Support Tickets",
    url: "orderList",
    element: <Orders />,
    children: [
      {
        type: "Orders",
        img: require("../assets/BuyerProfile/Panel/Orders.png"),
        url: "",
        element: <OrderList />,
      },
      {
        type: "Orders",
        img: require("../assets/BuyerProfile/Panel/Orders.png"),
        url: "track/:orderId",
        element: <TrackOrder />,
      },
      {
        type: "Orders",
        img: require("../assets/BuyerProfile/Panel/Orders.png"),
        url: "view/:orderId",
        element: <ViewDetails />,
      },
    ],
  },
];

export { RaiseTickets };
